// intl-tel-input validates through a utils script it loads at runtime. Until that script arrives,
// isPossibleNumber() is null and getValidationError() is -99, so every number reads "Invalid number"
// and Save stays disabled. It used to come from cdnjs, and a cdnjs stall did exactly that (E2E,
// Oct 28). angular.json copies the package's own copy into the build, so it ships with the app and
// matches the installed library version.
export const telUtilsScript = 'assets/intl-tel-input/utils.js';

export const telErrorMap = [
  'Invalid number',
  'Invalid country code',
  'Too short',
  'Too long',
  'Invalid number',
];
